/** Stable HSL color from a string (e.g. project name). Optional alpha 0–1. */
export function colorFromName(name, alpha) {
  const s = (name || "").trim() || "?";
  let hash = 0;
  for (let i = 0; i < s.length; i += 1) {
    hash = s.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  if (alpha == null) return `hsl(${hue} 52% 42%)`;
  return `hsl(${hue} 52% 42% / ${alpha})`;
}
